const SystemSetupRoutes = {
    path: '/system-setup',
    component: () => import('@/views/Layout.vue'),
    meta: {
        requiresAuth: false
    },
    children: [
        {
            name: 'user-setup',
            path: '/system-setup/user',
            meta: {
                permissions: 'user:list'
            },
            component: () => import('@/views/system-setup/user-setup/SearchUser.vue')
        },
        {
            name: 'user-setup-create',
            path: '/system-setup/user/:mode',
            meta: {
                permissions: 'user:create'
            },
            component: () => import('@/views/system-setup/user-setup/UserDetail.vue')
        },
        {
            name: 'user-setup-detail',
            path: '/system-setup/user/:mode/:id',
            meta: {
                permissions: 'user:edit'
            },
            component: () => import('@/views/system-setup/user-setup/UserDetail.vue')
        },
        {
            name: 'role-setup',
            path: '/system-setup/role',
            meta: {
                permissions: 'role:list'
            },
            component: () => import('@/views/system-setup/role-setup/SearchRole.vue')
        },
        {
            name: 'role-setup-create',
            path: '/system-setup/role/:mode',
            meta: {
                permissions: 'role:create'
            },
            component: () => import('@/views/system-setup/role-setup/RoleDetail.vue')
        },
        {
            name: 'role-setup-detail',
            path: '/system-setup/role/:mode/:id',
            meta: {
                permissions: 'role:edit'
            },
            component: () => import('@/views/system-setup/role-setup/RoleDetail.vue')
        },
        {
            name: 'job-setup',
            path: '/system-setup/job',
            meta: {
                permissions: 'schedule:list'
            },
            component: () => import('@/views/system-setup/job-setup/SearchJobSchedule.vue')
        },
        {
            name: 'job-setup-create',
            path: '/system-setup/job/:mode',
            meta: {
                permissions: 'schedule:create'
            },
            component: () => import('@/views/system-setup/job-setup/JobDetail.vue')
        },
        {
            name: 'job-setup-detail',
            path: '/system-setup/job/:mode/:id',
            meta: {
                permissions: 'schedule:edit'
            },
            component: () => import('@/views/system-setup/job-setup/JobDetail.vue')
        },
        {
            name: 'job-log',
            path: '/system-setup/job-log',
            meta: {
                permissions: 'joblog:list'
            },
            component: () => import('@/views/system-setup/job-setup/SearchJobLog.vue')
        }
    ]
};

export default SystemSetupRoutes;
